import React, { useEffect, useState } from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Avatar, Tooltip, Text } from '@chakra-ui/react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Link,
} from '@chakra-ui/react';
import { IconButton } from "@mui/material";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

// import { faBell, faCircleQuestion } from '@fortawesome/free-regular-svg-icons';
// import { faGear } from '@fortawesome/free-solid-svg-icons';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { redirect, useNavigate } from 'react-router-dom';
// import { faGear } from '@fortawesome/pro-regular-svg-icons';
import apiClient from '../clients/apiClient.js';

import thalamuslogo from './thalamuslogo.svg';
import harpreetProfile from './harpreet.png';
import { fetchOrganizationData } from '../services/api';

const TopBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [orgData, setOrgData] = useState({});

  console.log('[Topbar] Page rendered');

  useEffect(() => {
    const getData = async () => {
      const data = await fetchOrganizationData();
      console.log('[AccountPage] Data:', data);
      if (!data.error) {
        setOrgData(data);
      }
    };
    getData();
  }, []);

  const handleMenuToggle = () => setIsOpen(!isOpen);
  const handleMenuClose = () => setIsOpen(false);

  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        height: '60px',
        alignItems: 'center',
        marginLeft: '16px',
        marginRight: '24px',
      }}
    >
      <Text>

      </Text>
      <Stack direction="row" spacing={4}>
        <Tooltip label="Info" aria-label="A tooltip">
          <IconButton
            aria-label="info"
            onClick={() => {}}
            sx={{padding:0, "&:hover":{backgroundColor: "transparent"}}}
          ><HelpOutlineIcon sx={{ padding:0, fontSize: 24, color: "#5d5d5d", bgColor: "transparent" }}/></IconButton>
        </Tooltip>
        <Tooltip label="Notifications" aria-label="A tooltip">
          <IconButton
            sx={{padding:0, "&:hover":{backgroundColor: "transparent"}}}
            onClick={() => {}}
          ><NotificationsOutlinedIcon sx={{ padding:0, fontSize: 24, color: "#5d5d5d" }}/></IconButton>
        </Tooltip>
        <Tooltip label="User Settings" aria-label="A tooltip">
          <IconButton
            sx={{padding:0, "&:hover":{backgroundColor: "transparent"}}}
            onClick={() => {
              handleNavigate('/account-settings');
            }}
          >
            <SettingsOutlinedIcon sx={{ padding:0, fontSize: 24, color: "#5d5d5d" }}/>
          </IconButton>
        </Tooltip>
        <div style={{ paddingTop: '1px', paddingLeft: '1px'}}>
          <Menu>
            <MenuButton>
              <Avatar
                sx={{
                  boxSize: "40px"
                }}
                name={orgData?.personal_info?.name + " " + orgData?.personal_info?.last_name}
                src={orgData?.personal_info?.profile_photo}
              />
            </MenuButton>
            <MenuList>
              <MenuItem onClick={() => handleNavigate('/manage-account')}>
                Manage account
              </MenuItem>
              <MenuItem style={{ color: 'red' }} onClick={() => {
                apiClient.get("/logout").then((response) => {
                  if (response.request.responseURL) {
                    // Check if Axios detected a redirect
                    const redirectUrl = response.request.responseURL;
                    const url = new URL(redirectUrl);
                    console.log("Redirect Url", url.pathname);
                    handleNavigate(url.pathname);
                  }
                });
              }}>Sign out</MenuItem>
            </MenuList>
          </Menu>
        </div>
      </Stack>
    </div>
  );
};

export default TopBar;
